import * as constants from '../constants';
export { default as camelcaseKeys } from 'camelcase-keys';
export { default as snakecaseKeys } from 'snakecase-keys';

export const getRequestStateFlagsWithError = (requestState, requestError) => ({
  isIdle: requestState === constants.REQUEST_STATES.IDLE,
  isPending: requestState === constants.REQUEST_STATES.PENDING,
  isFulfilled: requestState === constants.REQUEST_STATES.FULFILLED,
  isRejected: requestState === constants.REQUEST_STATES.REJECTED,
  error: requestError,
  rawState: requestState,
});

export const isValidURL = (value) => {
  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

export const getCloudinaryUserAvatarThumbnailUrl = ({ s3Url, size }) => {
  return `https://res.cloudinary.com/upraised/image/fetch/c_thumb,g_face,w_${size},h_${size},f_auto,q_85/${s3Url}`;
};
